import { useQuery } from '@tanstack/react-query';
import { fetchLogs } from '../api/admin';

export function LogsPage() {
    const { data, isLoading } = useQuery({
        queryKey: ['logs'],
        queryFn: fetchLogs,
    });

    if (isLoading) {
        return <div className="text-center py-8">Loading logs...</div>;
    }

    const logs = data?.logs || [];

    return (
        <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                Logs & Audit Trail
            </h1>

            <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
                <div className="p-4 border-b border-gray-200 dark:border-gray-700">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                        Recent Activity
                    </h2>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead>
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    Timestamp
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    Type
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    License Key
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                    Details
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                            {logs.map((log: any) => (
                                <tr key={log.id}>
                                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-200">
                                        {log.timestamp ? new Date(log.timestamp).toLocaleString() : 'N/A'}
                                    </td>
                                    <td className="px-6 py-4">
                                        <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                                            {log.type}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 text-sm font-mono text-gray-600 dark:text-gray-400">
                                        {log.licenseKey || '-'}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-200">
                                        <pre className="text-xs">{JSON.stringify(log, null, 2)}</pre>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}